export default function() {
  return new Worker(__webpack_public_path__ + "search.worker-27341f891bc8b16af534.worker.js");
}
